<template>
  <div class="page page--bid-areas">
    <smart-block
        link="https://manurewa5yearplan.commonplace.is"
        background-color="#2D88BC"
        heading="Have your say"
    ></smart-block>
    <smart-block
        link="http://www.aucklandcouncil.govt.nz/report-problem/Pages/report-a-problem.aspx"
        background-color="#2D88BC"
        heading="Report a problem"
    ></smart-block>
  </div>
</template>

<script>
import SmartBlock from "@/components/SmartBlock.vue";
export default {
  components: {SmartBlock}
}
</script>

<style scoped lang="scss">
.page-block {
  padding: 2rem;
  .pretty-inner {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
    img {
      max-width: 40%;
    }
  }
}
</style>
